import LiveDeviceInteraction from 'src/containers/LiveDeviceInteraction/LiveDeviceInteraction';

export default LiveDeviceInteraction;